import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from "react";
import { Column } from "@tanstack/react-table";
import * as Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@repo/common/utils/cn";
export function HeaderCell(t0) {
  const $ = _c(13);
  const {
    children,
    column,
    sortable: t1,
    className
  } = t0;
  const sortable = t1 === undefined ? true : t1;
  if (!sortable) {
    let t2;
    if ($[0] !== children) {
      t2 = <Text.Heading size="sm">{children}</Text.Heading>;
      $[0] = children;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== column) {
    t2 = () => column.toggleSorting(column.getIsSorted() === "asc");
    $[2] = column;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className) {
    t3 = cn("text-sm font-normal text-foreground-muted hover:bg-gray-200", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== column) {
    t4 = column.getIsSorted() === "asc" ? <ChevronUp size={12} /> : <ChevronDown size={12} />;
    $[6] = column;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <Button variant="ghost" onClick={t2} className={t3}>{children}{t4}</Button>;
    $[8] = children;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}